export default __webpack_public_path__ + "static/media/view.ea3434ec.svg";